import React, { Component, PropTypes } from 'react';
import includes from 'lodash/includes';
import get from 'lodash/get';
import ReactSparkSelectInput from '../../widgets/ReactSparkSelectInput';
import ConfigurationCheckbox from '../../widgets/ConfigurationCheckbox';
import { ControlledRadioButton as SparkRadioButton } from '../../ui/sabre-spark-react-ex';
import { PRICE_DISPLAY_OPTIONS, PRICE_DISPLAY_TAX_FEE_OPTIONS } from '../../../constants/PricingDisplay';
import If from '../../helpers/if';

export default class PricingDisplaySection extends Component {
    constructor(props) {
        super(props);
    }

    getPrimaryPriceDisplayDefaultValue() {
        return get(this.props.currentConfigCopy, 'pricingDisplay', '');
    }

    handleShowBothClick(event) {
        const { value } = event.target;

        if (this.isShowBothSelected()) {
            return;
        }

        this.updatePricingDisplay(value + '#Total');
    }

    isShowBothSelected() {
        const { pricingDisplay } = this.props.currentConfigCopy;
        return includes(pricingDisplay, 'showBoth');
    }

    updatePricingDisplay(value) {
        this.props.setConfigText('pricingDisplay', null, value);
    }

    updateTaxAndFeeDisplay = (e) => {
        const value = get(e, 'target.value')
        this.props.setConfigText('pricingDisplayTaxAndFeeOption', null, value);
    }

    render() {
        const { pricingDisplay, pricingDisplayTaxAndFeeOption, autoExpandTaxDetails } = this.props.currentConfigCopy;
        const isBothSelected = includes(pricingDisplay, 'showBoth');
        const showTaxFeeBreakdown = get(this.props.currentConfigCopy, 'SHOW_TAX_FEE_DETAIL_IN_PRICE_BREAKDOWN');
        const showTaxFeeBreakdownOnChange = (code, value) => {
            this.props.toggleConfigBoolean(code, value);
            if (autoExpandTaxDetails && value) {
                this.props.toggleConfigBoolean('autoExpandTaxDetails', true);
            }
        }

        return (
            <div className="spark-panel__content col-lg-12">
                <h4>PRICING DISPLAY</h4>
                <div className="col-xs-12 spark-mar-b-2">
                    <h5 className='spark-epsilon no-text-transform'>Price to Display:</h5>
                    <SparkRadioButton
                        name="show-both"
                        value="showBoth"
                        checked={this.isShowBothSelected()}
                        onClick={event => this.handleShowBothClick(event)}
                        disabled={this.props.isDisabled}
                    >
                        <span>
                            Display <strong>nightly and total</strong> price of stay (recommended)
                        </span>
                    </SparkRadioButton>
                    {isBothSelected && (
                        <div className="margin-left-4">
                            <ReactSparkSelectInput
                                label="Price to show first"
                                isDisabled={this.props.isDisabled}
                                defaultValue={this.getPrimaryPriceDisplayDefaultValue()}
                                values={[
                                    { key: 'showBoth#Total', label: 'Total Price of Stay' },
                                    { key: 'showBoth#Nightly', label: 'Nightly Price' }
                                ]}
                                onChange={event => {
                                    this.updatePricingDisplay(event.target.value);
                                }}
                            />
                        </div>
                    )}
                    <SparkRadioButton
                        name="nightly-price-only"
                        value="showNightlyPrice"
                        checked={pricingDisplay === 'showNightlyPrice'}
                        onClick={event => this.updatePricingDisplay(event.target.value)}
                        disabled={this.props.isDisabled}
                    >
                        <span>Display <strong>nightly</strong> price only</span>
                    </SparkRadioButton>
                    <SparkRadioButton
                        name="total-price-only"
                        value="showTotalPrice"
                        checked={pricingDisplay === 'showTotalPrice'}
                        onClick={event => this.updatePricingDisplay(event.target.value)}
                        disabled={this.props.isDisabled}
                    >
                        <span>Display <strong>total</strong> price of stay only</span>
                    </SparkRadioButton>
                </div>

                <div className="col-xs-12 spark-mar-b-1">
                    <h5 className='spark-epsilon no-text-transform'>Price Format:</h5>
                    <ReactSparkSelectInput
                        label="Display Price Rounding"
                        isDisabled={this.props.isDisabled}
                        defaultValue={this.props.currentConfigCopy.showShoppingPriceAmount}
                        values={[
                            { key: 'decimals', label: 'With Decimals' },
                            { key: 'nearest', label: 'Nearest Whole Amount' },
                            { key: 'roundup', label: 'Rounded Up' },
                            { key: 'rounddown', label: 'Rounded Down' }
                        ]}
                        onChange={event => {
                            this.props.setConfigText('showShoppingPriceAmount', null, event.target.value);
                        }}
                    />
                    <ReactSparkSelectInput
                        label="Detail Price Rounding"
                        isDisabled={this.props.isDisabled}
                        defaultValue={this.props.currentConfigCopy.showDetailedPriceAmount}
                        values={[
                            { key: 'decimals', label: 'With Decimals' },
                            { key: 'nearest', label: 'Nearest Whole Amount' },
                            { key: 'roundup', label: 'Rounded Up' },
                            { key: 'rounddown', label: 'Rounded Down' }
                        ].map(v => ({ key: v.key, label: v.label }))}
                        onChange={event => {
                            this.props.setConfigText('showDetailedPriceAmount', null, event.target.value);
                        }}
                    />
                </div>
                <div className='spark-pad-1'>
                    <h5 className='spark-epsilon no-text-transform'>Tax and Fee Display Options:</h5>
                    <SparkRadioButton
                        name="include-taxes-fees"
                        value={PRICE_DISPLAY_TAX_FEE_OPTIONS.INCLUDE_TAXES_FEES}
                        checked={pricingDisplayTaxAndFeeOption === PRICE_DISPLAY_TAX_FEE_OPTIONS.INCLUDE_TAXES_FEES}
                        onClick={this.updateTaxAndFeeDisplay}
                        disabled={this.props.isDisabled}
                    >
                        <span>
                            Show prices including taxes and fees (recommended)
                        </span>
                    </SparkRadioButton>
                    <SparkRadioButton
                        name="include-fees-only"
                        value={PRICE_DISPLAY_TAX_FEE_OPTIONS.INCLUDE_FEES_ONLY}
                        checked={pricingDisplayTaxAndFeeOption === PRICE_DISPLAY_TAX_FEE_OPTIONS.INCLUDE_FEES_ONLY}
                        onClick={this.updateTaxAndFeeDisplay}
                        disabled={this.props.isDisabled}
                    >
                        <span>Show prices including all fees, including resort fees</span>
                    </SparkRadioButton>
                    <SparkRadioButton
                        name="exclude-taxes-fees"
                        value={PRICE_DISPLAY_TAX_FEE_OPTIONS.EXCLUDE_TAXES_FEES}
                        checked={pricingDisplayTaxAndFeeOption === PRICE_DISPLAY_TAX_FEE_OPTIONS.EXCLUDE_TAXES_FEES}
                        onClick={this.updateTaxAndFeeDisplay}
                        disabled={this.props.isDisabled}
                    >
                        <span>Show prices excluding taxes and fees</span>
                    </SparkRadioButton>
                </div>
                <div>
                    <ConfigurationCheckbox
                        title="Show taxes and fees in price details"
                        isDisabled={this.props.isDisabled}
                        code={'SHOW_TAX_FEE_DETAIL_IN_PRICE_BREAKDOWN'}
                        onChange={showTaxFeeBreakdownOnChange}
                        value={showTaxFeeBreakdown}
                    />
                    <If condition={showTaxFeeBreakdown}>
                        <ConfigurationCheckbox
                            className="spark-pad-l-2"
                            title="Automatically expand tax details in Price Summary"
                            isDisabled={this.props.isDisabled}
                            code={'autoExpandTaxDetails'}
                            onChange={this.props.toggleConfigBoolean}
                            value={autoExpandTaxDetails}
                        />
                    </If>
                </div>
            </div>
        );
    }
}
PricingDisplaySection.propTypes = {
    isDisabled: PropTypes.bool,
    registerSection: PropTypes.func,
    sectionStyleHandler: PropTypes.func,
    toggleConfigBoolean: PropTypes.func,
    setConfigText: PropTypes.func,
    currentConfigCopy: PropTypes.shape({
        SHOW_TAX_FEE_DETAIL_IN_PRICE_BREAKDOWN: PropTypes.bool,
        showDetailedPriceAmount: PropTypes.string,
        showShoppingPriceAmount: PropTypes.string,
        pricingDisplay: PropTypes.oneOf([
            PRICE_DISPLAY_OPTIONS.NIGHTLY_PRICE_ONLY,
            PRICE_DISPLAY_OPTIONS.TOTAL_PRICE_ONLY,
            PRICE_DISPLAY_OPTIONS.BOTH_PRICES_TOTAL_FIRST,
            PRICE_DISPLAY_OPTIONS.BOTH_PRICES_NIGHTLY_FIRST
        ]),
        pricingDisplayTaxAndFeeOption: PropTypes.oneOf([
            PRICE_DISPLAY_TAX_FEE_OPTIONS.EXCLUDE_TAXES_FEES,
            PRICE_DISPLAY_TAX_FEE_OPTIONS.INCLUDE_FEES_ONLY,
            PRICE_DISPLAY_TAX_FEE_OPTIONS.INCLUDE_TAXES_FEES
        ])
    })
};



// WEBPACK FOOTER //
// ./src/components/pages/sections/PricingDisplaySection.js